// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pkFm","col":"styles_col__AZ3mt"};